export default __webpack_public_path__ + "static/media/logo-vibe.3eba86da.png";